"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchParamsToServer = void 0;
__exportStar(require("./Identity"), exports);
__exportStar(require("./Identifiable"), exports);
__exportStar(require("./Location"), exports);
__exportStar(require("./User"), exports);
__exportStar(require("./WorkLogSummary"), exports);
__exportStar(require("./WorkLog"), exports);
__exportStar(require("./Project"), exports);
__exportStar(require("./Place"), exports);
__exportStar(require("./WorkType"), exports);
var searchParamsToServer = function (searchParams) {
    var sort = '{' +
        searchParams.orderBy.map(function (order) { return [order.id + ': ' + (order.desc ? -1 : 1)]; }).join(',') +
        '}';
    // When page is 0, full reaload
    var limit = searchParams.page === 0 ? searchParams.pageSize :
        Math.max(0, searchParams.pageSize * (searchParams.page + 1) - searchParams.loadedLength);
    return __assign({ search: searchParams.filterText, limit: limit, skip: searchParams.page === 0 ? 0 : searchParams.loadedLength, sort: sort }, searchParams.others);
};
exports.searchParamsToServer = searchParamsToServer;
